import React from 'react';
import { DefaultBsComponent } from '../../types/module';
import { classNames } from '../../utils/style';

export const BlogAskADemoImageBox = ({
  children,
  className,
  as: Component = 'div',
  ...props
}: DefaultBsComponent) => {
  return (
    <Component
      className={classNames(
        'BlogAskADemoImageBox',
        className,
        `relative overflow-hidden bg-blue-301 w-full md:w-1/2`,
        'self-stretch',
      )}
      {...props}
    >
      {children}
    </Component>
  );
};
